'use client';

import * as Collapsible from '@radix-ui/react-collapsible';
import React, { ReactNode } from 'react';

import { KeyboardArrowDown, KeyboardArrowUp } from '@lichtblick/icons';

import { CollapseIcon, Content, Header } from './Collapse.styles';

export type CollapseProps = {
  color?: string;
  content: ReactNode;
  header?: ReactNode;
  isOpen: boolean;
  setOpen?: (input: boolean) => void;
};

export const Collapse = ({ color, content, header, isOpen, setOpen }: CollapseProps) => {
  return (
    <Collapsible.Root className="CollapsibleRoot" onOpenChange={setOpen} open={isOpen}>
      <Collapsible.Trigger asChild>
        {header && (
          <Header className="Repository" data-testid="trigger">
            <CollapseIcon className="IconButton">{isOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}</CollapseIcon>
            {header}
          </Header>
        )}
      </Collapsible.Trigger>
      <Content $color={color}>{content}</Content>
    </Collapsible.Root>
  );
};
